import { Components, switchClasses, Theme } from '../../material';
import { borderRadius } from '../tokens';

const thumbSize = 16;

export const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      height: 36,
      width: 52,
      padding: theme.spacing(1),
    }),
    track: ({ theme }) => ({
      borderRadius: borderRadius.abs(10, 'xl'),
      opacity: 1,
      backgroundColor: theme.palette.action.focus,
    }),
    switchBase: ({ theme }) => ({
      padding: theme.spacing(1),
      color: theme.palette.getContrastText(theme.palette.primary.main),
      [`&.${switchClasses.disabled}`]: {
        color: theme.palette.action.disabled,
        [`& + .${switchClasses.track}`]: {
          opacity: 1,
          backgroundColor: theme.palette.action.disabledBackground,
        },
      },
      [`&.${switchClasses.checked}`]: {
        [`& + .${switchClasses.track}`]: {
          backgroundColor: theme.palette.success.main,
          opacity: 1,
        },
        [`&.${switchClasses.disabled}`]: {
          color: theme.palette.getContrastText(theme.palette.primary.main),
          [`& + .${switchClasses.track}`]: {
            opacity: 0.5,
          },
        },
        color: theme.palette.getContrastText(theme.palette.primary.main),
        transform: `translateX(${thumbSize}px)`,
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },

      '&:hover': {
        backgroundColor: 'transparent',
      },
    }),
    thumb: {
      margin: 2,
      width: thumbSize,
      height: thumbSize,
    },
  },
};
